export const missionVisionData = {
  mission: {
    short: "To build a thriving Africa by unlocking opportunities, promoting innovation, and providing strategic support across diverse industries, starting in Ghana and reaching across the continent.",
    full: "To build a thriving Africa by unlocking opportunities, promoting innovation, and providing strategic support across diverse industries, starting in Ghana and reaching across the continent."
  },
  vision: {
    short: "To build businesses that drive Africa's growth and transform lives.",
    full: "To build businesses that drive Africa's growth and transform lives."
  }
};